import { WinCreatedActivity } from '../../../store/modules/activities'
import { activityIconMap } from '../icon-map'
import { ActivityItemVm } from './activity-item-vm'

export class WinActivityItemVm extends ActivityItemVm<WinCreatedActivity> {
  get content() {
    return this.activity.record.content
  }

  get reactions() {
    return this.activity.record.reactions
  }

  get receivers() {
    return this.activity.record.winners
  }

  get recordId() {
    return this.activity.record.id
  }

  get skills() {
    return [
      ...this.activity.record.skills,
      ...this.activity.record.profileSkills.map((ps) => ({
        id: ps.id,
        name: ps.name,
        slug: null,
      })),
    ]
  }

  get icon() {
    return activityIconMap[this.title]
  }

  get title() {
    return this.activity.record.winCategory?.title || 'Win'
  }
}
